import React, {Component, createRef} from "react";
import { contactName } from "../../helpers/ContactName";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import Swal from "sweetalert2";
import MainHelper, {apiCall, formattedPrice} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class ReceivablesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    handleDelete = async (receiveId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/receivable/supplier/delete/'+receiveId,'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Alacak başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleReceivableDetail = (receiveId) => {
        this.props.history.push(`/receivable-supplier-detail/${receiveId}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewReceivablePermission = userPermissions.includes('view receivable');
        const userHasDeleteReceivablePermission = userPermissions.includes('delete receivable');
        const columns = [
            {
                name:'ID',
                selector:row => row.id,
                sortable:true
            },
            {
                name:'Fatura No',
                selector:row => row.invoice_no || "Fatura bulunamadı",
                sortable:true
            },
            {
                name:'Müşteri',
                selector:row => contactName(row.customer).toLocaleUpperCase("tr-TR"),
                sortable:true
            },
            {
                name:'Tip',
                selector:row => row.b_a === "alacak" ? "Alacak" : "Borç",
                sortable:true
            },
            {
                name:'Son Ödeme Tarihi',
                selector:row => MainHelper.dateFormat(row.due_date).split(' 0')[0]
            },
            {
                name:'Tutar',
                selector:row => formattedPrice(row.amount)
            },

            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>

                    {userHasDeleteReceivablePermission ? (
                        <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(row.id)} style={{cursor: 'pointer',marginLeft:-15}}>
                            <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                        </IconButton>
                    ):""}


                    </>
                )}

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/receivable/supplier/all"}
                columns={columns}
                onRowClicked={userHasViewReceivablePermission ? row => this.handleReceivableDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(ReceivablesTable));
